<template>
  <div>
    <b-row>
      <b-col md="8">
        <b-card>
          <ul class="list-group list-group-flush">
            <li
              v-for="value in instructions"
              :key="value"
              class="list-group-item"
            >
              <feather-icon color="success" icon="CheckCircleIcon" />
              {{ value.description }}
            </li>
          </ul>
        </b-card>
      </b-col>

      <b-col md="3">
        <b-card>
          <b-list-group flush>
            <b-list-group-item href="#">
              Order Id: <strong>{{ customerData.orderId }}</strong>
            </b-list-group-item>
            <b-list-group-item href="#">
              First Name: <strong>{{ customerData.firstName }}</strong>
            </b-list-group-item>
            <b-list-group-item href="#">
              Last Name: <strong>{{ customerData.lastName }}</strong>
            </b-list-group-item>
            <b-list-group-item href="#">
              Ammount: <strong>{{ customerData.ammount }}</strong>
            </b-list-group-item>
            <b-list-group-item href="#">
              Currency: <strong>{{ customerData.currency }}</strong>
            </b-list-group-item>
            <b-list-group-item href="#">
              <h3>Expiry date :{{ customerData.expiryDate }}</h3>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </div>
</template>

<script>
import {
  BCard,
  BOverlay,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol,
} from "bootstrap-vue";
import axios from "@axios";

export default {
  components: {
    BCard,
    BOverlay,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
  },
  data() {
    return {
      instructions: [],
      isLoading: false,
      customerData: {
        orderId: "Ep6687648754",
        firstName: "Abebe",
        lastName: "Mekonen",
        ammount: "600",
        currency: "ETB",
        isLoading: false,
        expiryDate: "2020-05-08 12:05PM",
      },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch(
        "config/getActionPrivilege",
        "MerchantFOP-ManageInstructions"
      );

      axios
        .get(
          `/PaymentOptions/api/V1.0/PaymentOptions/GetInstructions?paymentOptionId=${this.$route.query.id}`
        )
        .then((res) => {
          res.instructions.forEach((item) => {
            this.instructions.push({
              id: item.id,
              steps: item.steps,
              description: item.description,
              sequence: item.sequence,
            });
          });
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
        });
    },
  },
};
</script>
